
export const landingStats: LandingStat[] = [
  { id: "visitors", label: "Landing Visitors", value: "28.4k", change: "+22.1%", bg: "bg-primary-soft", color: "text-primary" },
  { id: "signups", label: "Sign Ups", value: "3,842", change: "+31.5%", bg: "bg-teal-soft", color: "text-teal" },
  { id: "conversion", label: "Conversion Rate", value: "13.5%", change: "+2.8%", bg: "bg-yellow-soft", color: "text-yellow" },
  { id: "cta", label: "CTA Clicks", value: "8,291", change: "+19.4%", bg: "bg-pink-soft", color: "text-pink" },
];

export const conversionData: ConversionPoint[] = [
  { week: "W1", signups: 420, conversions: 180 },
  { week: "W2", signups: 580, conversions: 245 },
  { week: "W3", signups: 510, conversions: 220 },
  { week: "W4", signups: 720, conversions: 310 },
  { week: "W5", signups: 680, conversions: 295 },
  { week: "W6", signups: 890, conversions: 380 },
];

export const ctaPerformance: CTAPerformance[] = [
  { name: "Get Started Free", clicks: 3240, rate: "18.2%" },
  { name: "Watch Demo", clicks: 2180, rate: "12.4%" },
  { name: "Contact Sales", clicks: 1560, rate: "8.9%" },
  { name: "Download PDF", clicks: 1311, rate: "7.5%" },
];

export const abTests: ABTest[] = [
  { variant: "Variant A — Blue CTA", visitors: 14200, conversions: 1920, winner: true },
  { variant: "Variant B — Green CTA", visitors: 14200, conversions: 1640 },
];
